"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calc = calc;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/** 计算根据路径进行 */
function calc(data, path, calculate) {
  if ((0, _typeof2["default"])(data) === 'object' && data !== null) {
    var paths = path.split('.');

    if (paths.length === 1) {
      if (typeof data[path] !== 'undefined') {
        data[path] = calculate(Number(data[path]), data[path]);
      }
    } else {
      var name = paths.shift();

      if (name === '[]') {
        if (Array.isArray(data)) {
          data.forEach(function (nest) {
            calc(nest, paths.join('.'), calculate);
          });
        }
      } else if (typeof name === 'string' && (0, _typeof2["default"])(data) === 'object') {
        calc(data[name], paths.join('.'), calculate);
      }
    }
  }
}